import type {
  IOption,
  LoadOptionsResult,
} from "@/components/common/AsyncSearchSelect";
import { ShiftService } from "@/services/Shift/Shift";
import { SiteService } from "@/services/Site/Site";
import type {
  IShift,
  IShiftListParams,
  IShiftListResponse,
} from "@/interface/shift.interface";
import type {
  ISite,
  ISiteListParams,
  ISiteListResponse,
} from "@/interface/site.interface";

const PAGE_SIZE = 20;

interface PaginatedAdditional {
  page: number;
}

const shiftToOption = (shift: IShift): IOption => ({
  value: shift.id,
  label: shift.shiftName,
});

const siteToOption = (site: ISite): IOption => ({
  value: site.id,
  label: site.siteName,
});

export const loadShiftOptions = async (
  search: string,
  _loadedOptions: unknown,
  additional: PaginatedAdditional = { page: 1 },
): Promise<LoadOptionsResult> => {
  try {
    const params: IShiftListParams = {
      search,
      pageIndex: additional.page,
      pageSize: PAGE_SIZE,
    };
    const res: IShiftListResponse = await ShiftService.getShiftList(params);
    return {
      options: res.data.rows.map(shiftToOption),
      hasMore: additional.page < res.data.totalPages,
      additional: { page: additional.page + 1 },
    };
  } catch (error) {
    console.error("Failed to load shifts", error);
    return { options: [], hasMore: false, additional: { page: 1 } };
  }
};

export const loadSiteOptions = async (
  search: string,
  _loadedOptions: unknown,
  additional: PaginatedAdditional = { page: 1 },
): Promise<LoadOptionsResult> => {
  try {
    const params: ISiteListParams = {
      search,
      pageIndex: additional.page,
      pageSize: PAGE_SIZE,
    };
    const res: ISiteListResponse = await SiteService.getSiteList(params);
    return {
      options: res.data.rows.map(siteToOption),
      hasMore: additional.page < res.data.totalPages,
      additional: { page: additional.page + 1 },
    };
  } catch (error) {
    console.error("Failed to load sites", error);
    return { options: [], hasMore: false, additional: { page: 1 } };
  }
};